module.exports = __webpack_public_path__ + "static/media/jawcore-1.8f4f454f.jpg";